var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressionDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 39,
    viewBox: "0 0 77 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5848 35.4213C76.7275 35.8102 76.5279 36.2411 76.139 36.3838L69.8021 38.7088C69.4132 38.8515 68.9823 38.652 68.8397 38.2631C68.697 37.8742 68.8966 37.4433 69.2854 37.3006L74.9182 35.2339L72.8515 29.6011C72.7088 29.2122 72.9084 28.7813 73.2973 28.6387C73.6861 28.496 74.1171 28.6956 74.2597 29.0844L76.5848 35.4213ZM0.3125 0.679688L0.627702 -0.000862122L76.1959 34.9991L75.8807 35.6797L75.5655 36.3602L-0.00270191 1.36024L0.3125 0.679688Z",
    fill: "#FC3040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressionDownArrow);
export default __webpack_public_path__ + "static/media/progressionDownArrow.83a29080f8d21b9eceb9545ecb01da35.svg";
export { ForwardRef as ReactComponent };